import { render } from "./ClientCMSContainer.vue?vue&type=template&id=b95720c0&scoped=true"
import script from "./ClientCMSContainer.vue?vue&type=script&lang=js"
export * from "./ClientCMSContainer.vue?vue&type=script&lang=js"

import "./ClientCMSContainer.vue?vue&type=style&index=0&id=b95720c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b95720c0"]])

export default __exports__